module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/solution2_1@2x-14734b3e541cfc6b33d101c62360a645.png";